import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';
import {
  Card as CardComponent,
  CardAndButtonsWrapper as CardAndButtonsWrapperComponent,
  DeleteDesktop as DeleteDesktopComponent,
  DeleteMobile as DeleteMobileComponent,
  DeleteMobileIcon as DeleteMobileIconComponent,
  EndWrapper as EndWrapperComponent,
  MiddleWrapper as MiddleWrapperComponent,
  Name as NameComponent,
  SmallText as SmallTextComponent,
  Wrapper as WrapperComponent,
} from '@/views/ShoppingBagView/components/ShoppingBagCard/ShoppingBagCard.styles';

import type { EngravingCardSize } from './EngravingCard';

import { ReactComponent as EditSVG } from '@/assets/edit.svg';

export const Wrapper = styled(WrapperComponent)`
  ${({ $isRelatedProduct }) => css`
    ${$isRelatedProduct &&
    css`
      width: 100%;
    `}
  `}
  padding-bottom: ${({ theme }) => theme.spacing(2)};
  margin-bottom: 0;
`;

export const Card = styled(CardComponent)`
  padding-left: 0;
`;

export const MiddleWrapper = styled(MiddleWrapperComponent)<{
  $size?: EngravingCardSize;
}>`
  flex-direction: column;
  gap: ${({ $size, theme }) => $size !== 'small' && theme.spacing(1)};
  justify-content: space-between;
  padding-bottom: 0;
`;

export const EngravingInfo = styled(Flex)<{
  $size?: EngravingCardSize;
}>`
  flex-direction: column;
  gap: ${({ $size, theme }) => $size !== 'small' && theme.spacing(1)};
`;

export const EngravingData = styled(Typography).attrs({ as: 'span' })<{
  $isText?: boolean;
  $size?: EngravingCardSize;
  $style?: string;
}>`
  display: flex;
  flex-direction: row;
  color: ${({ theme }) => theme.colors.primaryDark};
  gap: ${({ theme }) => theme.spacing(1)};
  font-size: ${({ $size, theme }) =>
    $size === 'small' ? theme.fontSizes.p3 : theme.fontSizes.p2};
  line-height: ${({ $size, theme }) =>
    $size === 'small' ? theme.lineHeights.p3 : theme.lineHeights.p2};

  p {
    color: ${({ theme }) => theme.colors.primaryDark};
    font-size: ${({ $size, theme }) =>
      $size === 'small' ? theme.fontSizes.p2 : theme.fontSizes.p1};
    font-family: ${({ $style, theme }) =>
      $style === 'Cursive'
        ? theme.fontFamilies.engravingCursive
        : theme.fontFamilies.engravingBlock};
  }
`;

export const EndWrapper = styled(EndWrapperComponent)``;

export const Name = styled(NameComponent)<{
  $size?: EngravingCardSize;
}>`
  font-size: ${({ $size, theme }) =>
    $size === 'small' ? theme.fontSizes.p1 : theme.fontSizes.p0};
`;

export const SmallText = styled(SmallTextComponent)``;

export const DeleteMobile = styled(DeleteMobileComponent)<{
  $displayButtonAsIcon?: boolean;
}>`
  ${({ $displayButtonAsIcon, theme }) => css`
    ${theme.media.md.up} {
      display: ${$displayButtonAsIcon ? 'inline-flex' : 'none'};
    }
  `}
`;

export const DeleteMobileIcon = styled(DeleteMobileIconComponent)``;

export const DeleteDesktop = styled(DeleteDesktopComponent)`
  text-align: right;
`;

export const EditDesktop = styled(DeleteDesktopComponent)`
  text-align: right;
`;

export const EditMobile = styled(EditSVG)`
  cursor: pointer;
  width: 24px;
  height: 24px;

  ${({ theme }) => css`
    ${theme.media.md.up} {
      display: none;
    }
  `}
`;

export const CardAndButtonsWrapper = styled(CardAndButtonsWrapperComponent)``;

export const ButtonsWrapper = styled(Flex)`
  flex-direction: column;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing(1)};
`;
